import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import eventSessionsKeys from 'actions/eventSessions/queryKeys';
import api from 'utils/api';
import config from 'utils/config';
import { getPageOffset } from 'utils/pagination';
import { ASSET_READ, ASSET_WRITE, hasPrivilege } from 'utils/privileges';
export var ATTENDEES_PER_PAGE = 20;
export var useFetchEventSessionAttendees = function useFetchEventSessionAttendees(_ref) {
  var _data$items;
  var eventId = _ref.eventId,
    sessionId = _ref.sessionId,
    _ref$page = _ref.page,
    page = _ref$page === void 0 ? 1 : _ref$page,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? ATTENDEES_PER_PAGE : _ref$limit,
    status = _ref.status,
    search = _ref.search,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    queryOptions = _ref.queryOptions;
  function fetchAttendees() {
    return _fetchAttendees.apply(this, arguments);
  }
  function _fetchAttendees() {
    _fetchAttendees = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var offset;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            offset = getPageOffset({
              page: page,
              itemsPerPage: limit
            });
            return _context.abrupt("return", api('get', "/api/assets/".concat(eventId, "/sessions/").concat(sessionId, "/attendees"), _objectSpread(_objectSpread({
              limit: limit,
              offset: offset
            }, status ? {
              status: status
            } : {}), search ? {
              search: search
            } : {})));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchAttendees.apply(this, arguments);
  }
  var _useQuery = useQuery(_objectSpread(_objectSpread({
      queryKey: eventSessionsKeys.eventSessionAttendees({
        eventId: eventId,
        sessionId: sessionId,
        page: page,
        status: status,
        search: search,
        limit: limit
      }),
      queryFn: fetchAttendees,
      placeholderData: keepPreviousData
    }, queryOptions), {}, {
      enabled: enabled && config.eventAssets && (hasPrivilege(ASSET_READ) || hasPrivilege(ASSET_WRITE))
    })),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded);
  return _objectSpread(_objectSpread({}, result), {}, {
    items: (_data$items = data === null || data === void 0 ? void 0 : data.items) !== null && _data$items !== void 0 ? _data$items : [],
    total: data === null || data === void 0 ? void 0 : data.total,
    nextOffset: data === null || data === void 0 ? void 0 : data.nextOffset
  });
};
export default useFetchEventSessionAttendees;